import React, { useEffect, useState } from 'react';
import { Edit } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { stagesApi, Stage } from '../services/stagesApi';

interface ContactInfoProps {
    contact: {
        id?: string;
        name: string;
        company: string;
        email: string;
        phone: string;
        value: string;
        stage: string;
    };
    leadId?: string;
    onEdit: () => void;
    onStageChange?: (newStage: string) => void;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ contact, leadId, onEdit, onStageChange }) => {
    const [stages, setStages] = useState<Stage[]>([]);

    useEffect(() => {
        stagesApi.fetchStages().then(setStages);
    }, []);

    const handleStageChange = (value: string) => {
        onStageChange?.(value);
    };

    return (
        <div className="border-l rounded-lg border-maxi-border bg-gray-200 p-6 space-y-6">
            {/* Contact Information */}
            <div className="space-y-4">
                <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-maxi-text-dark">
                        Información Contacto
                    </h3>
                    <Button variant="ghost" size="icon" onClick={onEdit}>
                        <Edit className="w-4 h-4 text-maxi-text" />
                    </Button>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm">
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Nombre</p>
                        <p className="text-maxi-text-dark">{contact.name}</p>
                    </div>
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Empresa</p>
                        <p className="text-maxi-text-dark">{contact.company || '—'}</p>
                    </div>
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Correo</p>
                        <p className="text-maxi-text-dark">{contact.email || '—'}</p>
                    </div>
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Valor</p>
                        <p className="text-maxi-text-dark">{contact.value}</p>
                    </div>
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Celular</p>
                        <p className="text-maxi-text-dark">{contact.phone}</p>
                    </div>
                    <div>
                        <p className="text-maxi-text font-medium mb-1">Etapa</p>
                        <Select value={contact.stage} onValueChange={handleStageChange}>
                            <SelectTrigger className="h-8 text-xs">
                                <SelectValue placeholder="Seleccionar etapa" />
                            </SelectTrigger>
                            <SelectContent>
                                {stages.map((stage) => (
                                    <SelectItem key={stage.id} value={stage.name}>
                                        <span className="flex items-center gap-2">
                                            <span
                                                className="w-2 h-2 rounded-full inline-block"
                                                style={{ backgroundColor: stage.color || '#6366F1' }}
                                            />
                                            {stage.name}
                                        </span>
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInfo;
